import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Wordmark } from '../lib/ui';
import { Icon } from '../lib/icons';

const COLS = [
  {
    h: 'ลูกแชร์ & ท้าวแชร์', s: 'ดำเนินการเองทุกขั้น', color: 'oklch(0.62 0.12 38)',
    items: ['ตั้งวงผ่าน wizard · ระบบ enforce กฎหมายอัตโนมัติ', 'ประมูลและจ่ายเงินกันเองตามจริง',
      'แนบสลิป/บันทึกผลเป็นหลักฐาน', 'นัดเจอหน้าด้วย QR check-in', 'ทวงหนี้กันเองในแชทกลุ่ม'],
  },
  {
    h: 'Smart system', s: 'automation ที่ไม่ต้องขออนุมัติ', color: PS.ink,
    items: ['ตรวจสอบกฎ พ.ร.บ. แบบ real-time', 'seal ทุก event ด้วย SHA-256 + ลายเซ็น',
      'เชื่อม hash chain ทุก event แก้ย้อนหลังไม่ได้', 'Timeline + audit log อัตโนมัติ', 'แจ้งเตือน · scoring · reminder'],
  },
  {
    h: 'Peershare (platform)', s: 'มีหน้าที่เดียว: เป็น custodian', color: 'oklch(0.48 0.08 155)',
    items: ['เก็บ evidence ทุกชิ้นแบบ immutable', 'ออก sealed package เมื่อมีผู้ขอ (dispute)',
      'ให้ตรวจสอบ hash ได้', 'ไม่ตัดสินใจใคร · ไม่เป็นคู่สัญญา', 'ไม่ถือเงินของลูกค้าเอง'],
  },
];

const STEPS = [
  { t: '1', l: 'ตั้งวง', who: 'ท้าว', color: 'oklch(0.62 0.12 38)' },
  { t: '2', l: 'เชิญ/ยอมรับ', who: 'สมาชิก', color: 'oklch(0.62 0.12 38)' },
  { t: '3', l: 'เซ็นสัญญา', who: 'ทุกคน', color: 'oklch(0.62 0.12 38)' },
  { t: '4', l: 'ประมูล/จ่าย', who: 'สมาชิก', color: 'oklch(0.62 0.12 38)' },
  { t: '5', l: 'แนบหลักฐาน', who: 'สมาชิก', color: PS.ink },
  { t: '6', l: 'Audit + seal', who: 'ระบบ', color: PS.ink },
  { t: '7', l: 'เก็บหลักฐาน', who: 'Peershare', color: 'oklch(0.48 0.08 155)' },
  { t: '8', l: 'ส่ง package', who: 'Peershare', color: 'oklch(0.48 0.08 155)' },
];

const KPIS = [
  { l: 'event ทั้งระบบ (24 ชม.)', v: '18,472', sub: 'hash · timestamp · signed' },
  { l: 'ข้อพิพาทเดือนนี้', v: '7', sub: 'ออก package < 2 นาที' },
  { l: 'human intervention', v: '0', sub: 'ระบบทำตามกฎในสัญญา' },
];

export default function About() {
  const nav = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: PS.page, color: PS.text, fontFamily: PS.fontUI }}>
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button data-testid="about-back-btn" onClick={() => nav(-1)} className="ps-press" style={{ display: 'flex', gap: 8, alignItems: 'center', border: 'none', background: 'transparent', color: PS.text, fontFamily: PS.fontUI, fontSize: 14 }}>
          <Icon.chevronL size={18} stroke={PS.ink} /> <Wordmark size={20} />
        </button>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', padding: '7px 14px', background: 'oklch(0.48 0.08 155)', color: '#fff', borderRadius: 999, fontSize: 12, fontWeight: 600 }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#fff' }} /> AUTOPILOT · ไม่มี operator
        </div>
      </div>

      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '20px 24px 60px' }}>
        <div style={{ fontSize: 11, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase' }}>หลักการทำงานของ platform</div>
        <div style={{ fontSize: 'clamp(24px,4vw,30px)', fontWeight: 700, letterSpacing: -0.5, marginTop: 6 }}>
          Peershare ไม่ใช่คู่สัญญา <span style={{ color: PS.textMuted }}>— เราเป็นผู้เก็บหลักฐาน</span>
        </div>

        <div style={{ marginTop: 28, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px,1fr))', gap: 18 }}>
          {COLS.map((c, i) => (
            <div key={i} style={{ background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 16, padding: 20 }}>
              <div style={{ width: 8, height: 8, background: c.color, transform: 'rotate(45deg)', marginBottom: 10 }} />
              <div style={{ fontSize: 15, fontWeight: 700 }}>{c.h}</div>
              <div style={{ fontSize: 11.5, color: PS.textMuted, marginTop: 3 }}>{c.s}</div>
              <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {c.items.map((it, k) => (
                  <div key={k} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <div style={{ width: 4, height: 4, borderRadius: '50%', background: c.color, marginTop: 7, flexShrink: 0 }} />
                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>{it}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 28, padding: 22, background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 600 }}>วงจรชีวิตวงแชร์ — ไม่มี human ที่ platform</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 18, gap: 8 }}>
            {STEPS.map((s, i) => (
              <div key={i} style={{ flex: '1 1 120px', minWidth: 120, padding: '14px 14px', borderRadius: 10, background: `color-mix(in oklch, ${s.color} 8%, transparent)`, borderLeft: `3px solid ${s.color}` }}>
                <div style={{ fontSize: 10, color: s.color, letterSpacing: 0.8, textTransform: 'uppercase', fontWeight: 700 }}>STEP {s.t}</div>
                <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4 }}>{s.l}</div>
                <div style={{ fontSize: 10.5, color: PS.textMuted, marginTop: 2 }}>โดย {s.who}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ marginTop: 18, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16 }}>
          {KPIS.map((k, i) => (
            <div key={i} style={{ background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 12, padding: 18 }}>
              <div style={{ fontSize: 10.5, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase' }}>{k.l}</div>
              <div className="num" style={{ fontSize: 30, marginTop: 6, fontWeight: 500, letterSpacing: -0.5 }}>{k.v}</div>
              <div style={{ fontSize: 11, color: PS.textMuted, marginTop: 4 }}>{k.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
